import React, { Fragment } from 'react'

import SearchIcon from '../../../../../assets/portalAssets/searchbarIconW.png'

import classes from './SideNavV2-Item.module.css'

import { Link, NavLink } from 'react-router-dom';

function SideNavItem(props) {
    return (
        <NavLink
            to={props.route}
            onClick={props.onClick}
            className={({ isActive }) => {
                const linkClasses = [classes['SideNav-item'], classes['itemName'], 'sidenav-tooltip'];
                if (isActive) linkClasses.push(classes.active);
                if (props.hideText) linkClasses.push(classes.iconOnly);
                return linkClasses.join(" ");
            }}
            end={props.end || null}
            data-pr-tooltip={props.text}
            data-pr-position="right"
        >
            <img className={classes.img} src={props.image} alt={props.alt} />
            {!props.hideText && <h3>{props.text}</h3>}

        </NavLink>
    )
}

export default React.memo(SideNavItem);